<template>
<section id="forgot">
    <NavbarDefault route="/" />
    <div class="container pt-5 success">
        <div class="row d-flex justify-content-center">
            <div class="col-10">
                <Button @click="$router.go(-1)" size="small" type="outline" color="grey">
                    <ArrowDropdown :rotate="90" /> Voltar
                </Button>
            </div>
            <div class="col-4 mb-5">
                <h2 :class="`text-center c-${getPrimaryColor}four`">Recuperar senha</h2>
                <p class="text-center mb-5">
                    Insira o e-mail cadastrado anteriormente para enviarmos um <br> e-mail de recuperação para você.
                </p>
                <el-form @keydown.native="invalidCredetials = false" :model="forgot" ref="forgot" :rules="rules">
                    <el-form-item prop="email">
                        <InputText label="E-mail" v-model="forgot.email" @keyup.native="validateForgot" placeholder="Seu e-mail"/>
                    </el-form-item>
                    <div class="spacer"></div>
                    <Button :disabled="!formValid" size="large" @click="sendEmailForgot" :color="getPrimaryColor">
                        Enviar
                    </Button>
                </el-form>
            </div>
        </div>
    </div>
    <Footer />
</section>
</template>

<script>
import NavbarDefault from '@/components/navigation/navbar/NavbarDefault'
import ArrowDropdown from '@/components/icons/ArrowDropdown'
import Footer from '@/components/navigation/footer/Footer'
import forgotPassword from '@/api/forgotPassword'
import getPartner from '@/utils/getPartner'

export default {
    components: {
        NavbarDefault,
        ArrowDropdown,
        Footer,
    },
    data() {
        const invalidLogin = (_rule, _value, message) => {
            if (this.invalidCredetials) message('Opa! Não conhecemos este e-mail.')
            else message()
        }
        return {
            forgot: {
                email: '',
                partner: '',
            },
            rules: {
                email: [{
                        required: true,
                        message: 'Por favor, insira o seu e-mail',
                        trigger: 'blur'
                    },
                    {
                        type: 'email',
                        message: 'Por favor, insira um e-mail válido',
                        trigger: 'blur'
                    },
                    {
                        validator: invalidLogin,
                        trigger: 'blue'
                    }
                ]
            },
            formValid: false,
            invalidCredetials: false,
        }
    },
    methods: {
        validateForgot() {
            this.$refs['forgot'].validate((valid) => {
                this.formValid = valid
            });
        },
        async sendEmailForgot() {
            const result = await forgotPassword(this.forgot)
            console.log(result)
            if (result.status == 200 && result.data.ok) {
                localStorage.requestForgot = true;
                localStorage.email = this.forgot.email
                this.$router.push('/forgot/success')
            } else {
                this.invalidCredetials = true
                this.validateForgot()
            }
        }
    },
    async created(){
        this.forgot.partner = await getPartner(this.getWhiteLabel)

    },
 }
</script>

<style scoped>
.width-880{
    max-width:880px;
}
.spacer {
    height: 34px;
}
</style>
